import React, { createContext, ReactNode, useContext, useState } from 'react';

interface MessageDraft {
  message: string;
}

interface AssistantContextType {
  // Message draft functionality
  messageDraft: MessageDraft | null;
  setMessageDraft: (draft: MessageDraft | null) => void;
}

const AssistantContext = createContext<AssistantContextType | undefined>(
  undefined,
);

interface AssistantProviderProps {
  children: ReactNode;
}

export const AssistantProvider: React.FC<AssistantProviderProps> = ({
  children,
}) => {
  const [messageDraft, setMessageDraft] = useState<MessageDraft | null>(null);

  const value: AssistantContextType = {
    messageDraft,
    setMessageDraft,
  };

  return (
    <AssistantContext.Provider value={value}>
      {children}
    </AssistantContext.Provider>
  );
};

export const useAssistantContext = (): AssistantContextType => {
  const context = useContext(AssistantContext);
  if (context === undefined) {
    throw new Error(
      'useAssistantContext must be used within an AssistantProvider',
    );
  }
  return context;
};
